import { ReviewCommentsPaginatedResponseDto } from '@bitecritic-api/src/review-comments/dto/review-comments-paginated.response.dto';
import requestService from '~/services/requestsService/requests.service';

const basePath = 'review-comments';

/**
 * Fetch comments for a specific review
 * @param reviewId - ID of the review
 * @param limit - Maximum number of comments to fetch
 * @param offset - Offset for pagination
 * @returns Promise with paginated comments and total count
 */
const getCommentsByReviewId = async (
  reviewId: string,
  limit = 10,
  offset = 0,
) => {
  return requestService.fetch<ReviewCommentsPaginatedResponseDto>(`${basePath}/review/${reviewId}`, { params: { limit, offset } });
};

/**
 * Create a new comment
 * @param reviewId - ID of the review
 * @param text - Comment text
 * @returns Promise with the created comment
 */
const createComment = async (reviewId: string, text: string) => {
  return requestService.post(`${basePath}`, { reviewId, text });
};

/**
 * Delete a comment
 * @param commentId - ID of the comment to delete
 * @returns Promise that resolves when the comment is deleted
 */
const deleteComment = async (commentId: string) => {
  return requestService.delete(`${basePath}/${commentId}`);
};

const reviewCommentsService = {
  getCommentsByReviewId,
  createComment,
  deleteComment,
};

export default reviewCommentsService; 